// Generated by CoffeeScript 2.7.0
var SignatureMixin;

export default SignatureMixin = {
  props: {
    portraitWidth: {
      type: Number,
      default: 500
    }
  },
  data: function() {
    return {
      signaturePad: null,
      canvas: '',
      showHelper: true,
      enableExpand: true,
      portrait: false
    };
  },
  created: function() {
    return this._reset();
  },
  mounted: function() {
    return this.$_init();
  },
  watch: {
    portrait: function() {
      return this.$nextTick(function() {
        return this.resizeCanvas();
      });
    }
  },
  methods: {
    $_init: function() {
      this.canvas = this.$refs.signature_pad;
      this.signaturePad = new SignaturePad(this.canvas, {
        maxWidth: 5,
        onBegin: () => {
          return this.showHelper = false;
        }
      });
      this.resizeCanvas();
      return window.addEventListener('resize', () => {
        this._reset();
        return this.resizeCanvas();
      }, false);
    },
    toggleExpand: function() {
      return this.portrait = !this.portrait;
    },
    getSignature: function(callback) {
      if (callback) {
        return callback();
      } else {
        return this.signaturePad.toDataURL();
      }
    },
    displaySignatureEmptyError: function() {
      return console.log('请签字');
    },
    rotateSignature: function(img) {
      var ctx;
      ctx = this.canvas.getContext('2d');
      this.canvas.width = img.width;
      this.canvas.height = img.height;
      ctx.drawImage(img, 0, 0);
      this.canvas.width = img.height;
      this.canvas.height = img.width;
      ctx.rotate(270 * Math.PI / 180);
      ctx.drawImage(img, -img.width, 0);
      return this.canvas;
    },
    clear: function() {
      this.signaturePad.clear();
      return this.showHelper = true;
    },
    resizeCanvas: function() {
      var ratio;
      ratio = Math.max(window.devicePixelRatio || 1, 1);
      this.canvas.width = this.canvas.offsetWidth * ratio;
      this.canvas.height = this.canvas.offsetHeight * ratio;
      this.canvas.getContext("2d").scale(ratio, ratio);
      return this.clear();
    },
    _reset: function() {
      this.portrait = false;
      return this.enableExpand = Boolean(window.innerWidth < this.portraitWidth);
    },
    removeBlanks: function() {
      var cropBottom, cropLeft, cropRight, cropTop, data, getAlpha, imageData, imgHeight, imgWidth, relevantData, scanX, scanY;
      imgWidth = this.signaturePad._ctx.canvas.width;
      imgHeight = this.signaturePad._ctx.canvas.height;
      imageData = this.signaturePad._ctx.getImageData(0, 0, imgWidth, imgHeight);
      data = imageData.data;
      getAlpha = function(x, y) {
        return data[(imgWidth * y + x) * 4 + 3];
      };
      scanY = function(fromTop) {
        var _loop, i, j, len, offset, ref, ref1, ref2, x, y;
        offset = fromTop ? 1 : -1;
        _loop = fromTop ? (function() {
          var results = [];
          for (var i = 0; 0 <= imgHeight ? i < imgHeight : i > imgHeight; 0 <= imgHeight ? i++ : i--){ results.push(i); }
          return results;
        }).apply(this) : (function() {
          var results = [];
          for (var i = 0, ref = imgHeight - 1; 0 <= ref ? i <= ref : i >= ref; 0 <= ref ? i++ : i--){ results.push(i); }
          return results;
        }).apply(this);
        ref1 = offset;
        // loop through each row
        for ((ref1 > 0 ? (i = 0, len = _loop.length) : i = _loop.length - 1); ref1 > 0 ? i < len : i >= 0; i += ref1) {
          y = _loop[i];
// loop through each column
          for (x = j = 0, ref2 = imgWidth; (0 <= ref2 ? j < ref2 : j > ref2); x = 0 <= ref2 ? ++j : --j) {
            if (getAlpha(x, y)) {
              return y;
            }
          }
        }
        return null; // all image is white
      };
      scanX = function(fromLeft) {
        var _loop, i, j, len, offset, ref, ref1, ref2, x, y;
        offset = fromLeft ? 1 : -1;
        _loop = fromLeft ? (function() {
          var results = [];
          for (var i = 0; 0 <= imgWidth ? i < imgWidth : i > imgWidth; 0 <= imgWidth ? i++ : i--){ results.push(i); }
          return results;
        }).apply(this) : (function() {
          var results = [];
          for (var i = 0, ref = imgWidth - 1; 0 <= ref ? i <= ref : i >= ref; 0 <= ref ? i++ : i--){ results.push(i); }
          return results;
        }).apply(this);
        ref1 = offset;
        // # loop through each column
        for ((ref1 > 0 ? (i = 0, len = _loop.length) : i = _loop.length - 1); ref1 > 0 ? i < len : i >= 0; i += ref1) {
          x = _loop[i];
// loop through each row
          for (y = j = 0, ref2 = imgHeight; (0 <= ref2 ? j < ref2 : j > ref2); y = 0 <= ref2 ? ++j : --j) {
            if (getAlpha(x, y)) {
              return x;
            }
          }
        }
        return null; // all image is white
      };
      cropTop = scanY(true);
      cropBottom = scanY(false);
      cropLeft = scanX(true);
      cropRight = scanX(false);
      relevantData = this.signaturePad._ctx.getImageData(cropLeft, cropTop, cropRight - cropLeft, cropBottom - cropTop);
      this.signaturePad._canvas.width = cropRight - cropLeft;
      this.signaturePad._canvas.height = cropBottom - cropTop;
      this.signaturePad._ctx.clearRect(0, 0, cropRight - cropLeft, cropBottom - cropTop);
      return this.signaturePad._ctx.putImageData(relevantData, 0, 0);
    }
  }
};
